module.exports = __webpack_public_path__ + "static/media/12BMCAmuralinstallation.ac49869f.webp";